import { Component } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-connections',
    imports: [RouterOutlet, MatTabsModule],
    templateUrl: './connections.component.html',
    styleUrl: './connections.component.scss',
    standalone: true,
})
export class ConnectionsComponent {
    protected get selectedTabIndex(): number {
        return this.router.url.includes('/connections/create') ? 1 : 0;
    }

    public constructor(private readonly router: Router) {}

    protected onTabChange(event: MatTabChangeEvent): void {
        if (event.index === 0) {
            if (!this.router.url.endsWith('/connections')) {
                this.router.navigate(['/connections']);
            }
        } else if (event.index === 1 && !this.router.url.includes('/connections/create')) {
            this.router.navigate(['/connections/create'], { queryParamsHandling: 'preserve' });
        }
    }
}
